/**
 * @ngdoc Service
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .service('ForgotPasswordService', ForgotPasswordService);

    /**
     * @constructor
     * @ngInject
     */
    function ForgotPasswordService($log, ApiService) {

        /* Public API */
        var service = {
            model: {
                email: null
            },
            requestPasswordReset: requestPasswordReset
        };

        return service;

        /* Private */

        /**
         * Do Stuff to request a password reset
         */
        function requestPasswordReset() {

            return ApiService
                .call('/auth/resetpassword', service.model)
                .then(function(response) {
                    return response.data.success;
                });
        }

    }
})();
